import BigNumber from "bignumber.js";
export const serializeRippleTransaction = ({ family, fee, tag, amount, recipient, }) => ({
    family,
    amount: amount.toString(),
    recipient,
    fee: fee ? fee.toString() : undefined,
    tag,
});
export const deserializeRippleTransaction = ({ family, fee, tag, amount, recipient, }) => ({
    family,
    amount: new BigNumber(amount),
    recipient,
    fee: fee ? new BigNumber(fee) : undefined,
    tag,
});
//# sourceMappingURL=serializer.js.map